
export const SMS_REPORT_LIST_REQUEST = 'SMS_REPORT_LIST_REQUEST';
export const SMS_REPORT_LIST_SUCCESS = 'SMS_REPORT_LIST_SUCCESS';
export const SMS_REPORT_LIST_FAILURE = 'SMS_REPORT_LIST_FAILURE';

export const TEMPLATE_INDEX_REQUEST = 'TEMPLATE_INDEX_REQUEST';
export const TEMPLATE_INDEX_SUCCESS = 'TEMPLATE_INDEX_SUCCESS';
export const TEMPLATE_INDEX_ERROR = 'TEMPLATE_INDEX_ERROR';

export const TEMPLATE_UPDATE_REQUEST = 'TEMPLATE_UPDATE_REQUEST';
export const TEMPLATE_UPDATE_SUCCESS = 'TEMPLATE_UPDATE_SUCCESS';
export const TEMPLATE_UPDATE_ERROR = 'TEMPLATE_UPDATE_ERROR';

export const TEMPLATE_CREATE_REQUEST = 'TEMPLATE_CREATE_REQUEST';
export const TEMPLATE_CREATE_SUCCESS = 'TEMPLATE_CREATE_SUCCESS';
export const TEMPLATE_CREATE_ERROR = 'TEMPLATE_CREATE_ERROR';

export const TEMPLATE_DELETE_REQUEST = 'TEMPLATE_DELETE_REQUEST';
export const TEMPLATE_DELETE_SUCCESS = 'TEMPLATE_DELETE_SUCCESS';
export const TEMPLATE_DELETE_ERROR = 'TEMPLATE_DELETE_ERROR';

export const SMS_SENT_INDEX_ERROR = 'SMS_SENT_INDEX_ERROR';
export const SMS_SENT_INDEX_REQUEST = 'SMS_SENT_INDEX_REQUEST';
export const SMS_SENT_INDEX_SUCCESS = 'SMS_SENT_INDEX_SUCCESS';

